/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portions_FewerInputs */

const en_portions_fewer = /** @type {(inputs: Portions_FewerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fewer portions`)
};

const de_portions_fewer = /** @type {(inputs: Portions_FewerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weniger Portionen`)
};

/**
* | output |
* | --- |
* | "Fewer portions" |
*
* @param {Portions_FewerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const portions_fewer = /** @type {((inputs?: Portions_FewerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portions_FewerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portions_fewer(inputs)
	return en_portions_fewer(inputs)
});